module.exports = __webpack_public_path__ + "img/nathan-bedford-forrest.4aa66cc9.png";